module.exports = __webpack_public_path__ + "img/flomakt.f689c006.jpg";